import isTouch from './is-touch'
import isPhone from './is-phone'
import getBrowser from './browser'
export default {
  get isTouch() {
    return isTouch()
  },
  get isPhone() {
    return isPhone()
  },
  /**
   * Get Browser Information
   */
  get getBrowser() {
    return getBrowser()
  },
}
